import { Title } from '@mantine/core'
import { useTheme } from './ThemeProvider'

interface LabeledTitleProps {
  title: string
}

export default function LabeledTitle({ title }: LabeledTitleProps) {
  const theme = useTheme()

  return (
    <div className="flex items-center">
      <Title order={4} c={theme?.primaryColor}>
        {title}
      </Title>
    </div>
  )
}
